import extend from 'lodash/extend';
import orderBy from 'lodash/orderBy';
import pull from 'lodash/pull';
import { Component, ComponentFactoryResolver } from '@angular/core';
import { CieUtilsModalManagerService } from '@cakeiteasy/web-utils';
import { UserApiService } from '../../../api-services/services/user-api.service';
import { IDeliveryAddress } from '../../../users/models/i-delivery-address';
import { DeliveryAddressModalComponent } from '../../modals/delivery-address-modal/delivery-address-modal.component';

@Component({
  standalone: false,
  selector: 'delivery-address',
  templateUrl: './delivery-address.component.html'
})
export class DeliveryAddressComponent {
  public deliveryAddresses: IDeliveryAddress[];
  public loaded: boolean = false;
  public loading: Promise<any>;

  constructor(private _users: UserApiService,
              private _modalManager: CieUtilsModalManagerService,
              private _componentResolver: ComponentFactoryResolver) {
    this._init();
  }

  public showDeliveryAddress(data = {}) {
    this._modalManager.show(DeliveryAddressModalComponent, this._componentResolver,
      { deliveryAddress: data },
      { windowClass: 'modal-simple', backdrop: 'static' })
      .then((da) => this._updateDeliveryAddress(da));
  }

  public deleteDeliveryAddress(deliveryAddress: IDeliveryAddress) {
    this._users.deleteDeliveryAddress(deliveryAddress.id)
      .then(() => pull(this.deliveryAddresses, deliveryAddress));
  }

  public setFavourite(deliveryAddressId: number) {
    this._users.setFavouriteDeliveryAddress(deliveryAddressId)
      .then((dAddress) => {
        const addresses = this.deliveryAddresses
          .map((da) => extend(da, { isFavourite: da.id === dAddress.id }));
        this.deliveryAddresses = orderBy(addresses, 'isFavourite', 'desc');
      });
  }

  private _updateDeliveryAddress(deliveryAddress) {
    const deliveryAddressForUpdate = this.deliveryAddresses.find((da) => da.id === deliveryAddress.id);
    if (deliveryAddressForUpdate) {
      extend(deliveryAddressForUpdate, deliveryAddress);
    } else {
      this.deliveryAddresses.push(deliveryAddress);
    }
  }

  private _init() {
    this.loading = this._users.getDeliveryAddresses()
      .then((deliveryAddresses) => {
        this.deliveryAddresses = deliveryAddresses;
        this.loaded = true;
      });
  }
}
